import { THEME } from '../constants';

export const inFocusColor = '#FDBF47';

export const FOCUSED_COLOR = '#FDBF47';

export const MY_COMPANY_COLOR = '#12bb4b';

export const COMMON_CHART_FONT_STYLES = {
  fontSize: '12px',
  fontWeight: 'normal',
  fontFamily: 'Inter',
};

const chartLabelColors = {
  [THEME.DARK]: '#9ba0a6',
  [THEME.LIGHT]: '#868686',
};

const chartBaseColors = {
  [THEME.DARK]: {
    RED: '#A9382D',
    GREEN: '#248D4E',
    BLUE: '#3862BA',
  },
  [THEME.LIGHT]: {
    RED: '#F43318',
    GREEN: '#12BB4B',
    BLUE: '#3674FF',
  },
};

const resonanceChartBaseColors = {
  [THEME.DARK]: {
    GREEN: '#7CC674',
    BLUE: '#519DE9',
  },
  [THEME.LIGHT]: {
    GREEN: '#7CC674',
    BLUE: '#519DE9',
  },
};

const chartValueColors = {
  [THEME.DARK]: '#ffffff',
  [THEME.LIGHT]: '#333333',
};

export const getChartFontColor = (theme) => chartLabelColors[theme ?? THEME.DARK];
export const getChartValueColor = (theme) => chartValueColors[theme ?? THEME.DARK];
export const getChartBaseColors = (theme) => chartBaseColors[theme];
export const getResonanceChartBaseColors = (theme) => resonanceChartBaseColors[theme];
export const getChartDataLabelColor = ({ inFocus, myCompany, theme }) => {
  if (myCompany) {
    return MY_COMPANY_COLOR;
  }

  if (inFocus) {
    return FOCUSED_COLOR;
  }

  return getChartFontColor(theme);
};
export const getChartGridColor = (theme) => (theme === THEME.DARK ? 'rgba(208,209,209,0.3)' : 'rgb(224, 224, 224)');

export const getTrendColor = ({ trend, score, isReversed, theme }) => {
  const MIN_SIGNIFICANT_DIFFERENCE = 0.1;
  const BASE_COLORS = getChartBaseColors(theme);

  if (trend - score > MIN_SIGNIFICANT_DIFFERENCE) {
    return isReversed ? BASE_COLORS.RED : BASE_COLORS.GREEN;
  }

  if (score - trend > MIN_SIGNIFICANT_DIFFERENCE) {
    return isReversed ? BASE_COLORS.GREEN : BASE_COLORS.RED;
  }

  return BASE_COLORS.BLUE;
};

export const getPositiveColor = ({ value, theme }) => {
  const BASE_COLORS = getChartBaseColors(theme);

  return +value < 0 ? BASE_COLORS.RED : BASE_COLORS.GREEN;
};

export const domainEntriesToChartData = (domainEntries, stat) => {
  const data = {
    domains: [],
    scores: [],
    trends: [],
    companyNames: [],
    metadata: {
      inFocus: [],
      groups: [],
    },
  };
  domainEntries.forEach(({ domain, [stat]: { score, trend }, inFocus, groups, companyName }) => {
    data.domains.push(domain);
    data.companyNames.push(companyName || '');
    data.scores.push(score);
    data.trends.push(trend);
    data.metadata.inFocus.push(inFocus);
    groups && data.metadata.groups.push(groups[0]);
  });
  if (data.trends.every((trend) => trend === undefined || trend === null || isNaN(trend))) {
    data.trends = null;
  }
  return data;
};

export const SONAR_DATA_KEYS = {
  INTEREST: 'interest',
  TRUST: 'trust',
  PASSION: 'passion',
  PRESENCE: 'presence',
  POWERRANK: 'powerrank',
  FRICTION: 'friction',
  ENERGY: 'energy',
  RELEVANCE_STRENGTH: 'relevanceStrength',
  RELEVANCE_BREADTH: 'relevanceBreadth',
};

export const EXTENDED_CHART_TYPES = {
  BUBBLES: 'bubbles',
  SCATTER: 'scatter',
};

export const getSortingByStat = (stat) => (firstEntry, secondEntry) =>
  secondEntry[stat]?.score - firstEntry[stat]?.score;

export const emptyValueIfNull = (value) => (value === null ? '-/-' : value);
export const isNull = (value) => value === null || value === undefined;
